/**
 * Recognises the `ConvexError({ kind: "unauthenticated", ... })` that
 * convex-reader's mutations throw for a caller with no usable reader
 * (`requireReader`), so a client can drop the dead session and offer
 * sign-in instead of surfacing a raw error. convex-lekterion's auth guard
 * throws the same `kind` shape.
 *
 * It does not match convex-retells, which throws
 * `ConvexError({ code: "unauthenticated" })`: a retells caller gets `false`
 * here and needs its own check on `data.code`.
 *
 * Structural rather than `instanceof ConvexError`: this package may not
 * depend on `convex`, and an error that crossed a bundle boundary or the
 * wire is not guaranteed to be an instance of the importing bundle's class.
 * What identifies the error is its `data` payload.
 */
export function isUnauthenticated(error: unknown): boolean {
  if (typeof error !== "object" || error === null || !("data" in error)) {
    return false;
  }
  const { data } = error;
  return (
    typeof data === "object" &&
    data !== null &&
    "kind" in data &&
    data.kind === "unauthenticated"
  );
}
